import React, { useState } from "react";
import "./SearchDocuments.scss";
import Footer from "../Footer";
import { Controller, useForm } from "react-hook-form";
import { Input } from "reactstrap";
import RadioButtonsProperty from "./RadioButtonsProperty";
import PropertyHeader from "../Header/PropertyHeader";
import FormSelector from "../FormSelector/FormSelector";
import { categories } from "./Data/Data";

export interface search {
  name: string;
  law_number: any;
  type: any;
  keywords: string;
}
type Props = {};

const SearchProperty = (Props: Props) => {

  const [isRadio, setIsRadio] = useState<any>(1);
  

  const [selectedCategory, setSelectedCategory] = useState("");
  const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCategory(event.target.value);
  };
  
  const { handleSubmit, control } = useForm<search>({ 
    defaultValues: {
      name: "",
      type: isRadio,
      keywords: "",
    },
    mode: "onChange",
    // resolver: yupResolver(UserInfoFormValidation),
  });

  if (!isRadio) {
    return null;
  }
  let searchType;
  let informationText: any;
  if (isRadio === 1) {
    searchType = "Law";
    informationText = "Ley";
  } else if (isRadio === 2) {
    searchType = "Joint Resolution";
    informationText = "RC";
  } else if (isRadio === 3) {
    searchType = "Veto";
    informationText = "vetos";
  } else if (isRadio === 4) {
    searchType = "Reglamento de Agencias";
    informationText = "Reglamento de Agencias";
  } else if (isRadio === 5) {
    searchType = "Reglamento Municipal";
    informationText = "Reglamento Municipal";
  } else if (isRadio === 6) {
    searchType = "Municipal Ordinance";
    informationText = "MO";
  } else if (isRadio === 7) {
    searchType = "Municipal Resolution";
    informationText = "M-Res";
  } else {
    searchType = "Law";
    informationText = "LEY";
  }

  return (
    <div className="search-document-page">
      <PropertyHeader />
      <div className="search-documents-container">
        <div className="search-document">
          <div className="form-container">
            <h1 className="page-title">Search for Intellectual Property</h1>
            <div className="radio-buttons">
              <RadioButtonsProperty
                isRadio={isRadio}
                setIsRadio={setIsRadio}
              />
            </div>

            <form
              className="search-documents-form"
              // onSubmit={handleSubmit}
            >
            <div className="search-bars">
              <h3 className="search-title">Search by Category:</h3>
              <FormSelector
                value={selectedCategory}
                options={categories}
                onChange={handleYearChange}
              />
            </div>
            
              <div className="search-bars">
                <h3 className="search-title">Search by:</h3>
                <Controller
                  name="name"
                  control={control}
                  defaultValue="name"
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => {
                    return (
                      <Input
                        value={value}
                        error={error}
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Search by Name"
                        onChange={onChange}
                        className="document-input"
                      />
                    );
                  }}
                />
                <Controller
                  name="keywords"
                  control={control}
                  defaultValue="keywords"
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => {
                    return (
                      <Input
                        value={value}
                        error={error}
                        id="keywords"
                        type="text"
                        name="keywords"
                        placeholder="Search by keywords"
                        onChange={onChange}
                        className="document-input"
                      />
                    );
                  }}
                />
              </div>
              <button
                className="document-button"
                type="submit"
              >
                Search
              </button>
              <div className="note">
                <h6>
                  if they require a certified law, please go through the
                  Department of State every time there is a cost.
                </h6>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div>
        {/* <div style={{ display: token ? "block" : "none" }}>
          <UserProfile />
        </div> */}
        <Footer />
      </div>
    </div>
  );
};

export default SearchProperty;
